import ReactDOMServer from "react-dom/server";
import { IndusPopupContainer } from "./popupTableHelper";
import { effectifValue } from "../table/tableHelper";
import { convertAssDomestique } from "./popupHelper";
import React from "react";

export const getInfoIndus = async (feature) => {
  let attributes,
    content = document.createElement('div');
  attributes = feature.graphic.attributes;
  const tableElements = {
    Commune: attributes['City'],
    'Note NAF': attributes['NAF_Note'],
    'Note RSDE': attributes['RSDE_Note'],
    'Assimilé domestique': convertAssDomestique(attributes['WarsmannNote']),
    'Nombre de salariés': effectifValue(attributes['SalariedWorkforceSlice']),
  };

  content.innerHTML = ReactDOMServer.renderToString(
    <IndusPopupContainer
      title='Etablissement'
      titleValue={attributes['Name']}
      tableElements={tableElements}
    />
  );
  return content;
}